export default "__VITE_ASSET__Dt2ltZEy__"